import { NearbyChargersResponse, TransactionDetailsResponse } from '@/central-atoms/everest-fleet-pwa/responses';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChargeFlowState {
  nearby_chargers: NearbyChargersResponse | null;
  transactionDetails: TransactionDetailsResponse | null;
}

const initialState: ChargeFlowState = {
  nearby_chargers: null,
  transactionDetails: null
};

const chargerDetailsSlice = createSlice({
  name: 'chargerDetails',
  initialState,
  reducers: {
    setNearbyChargers(state, action: PayloadAction<NearbyChargersResponse>) {
      state.nearby_chargers = action.payload;
    },
    setTransactionDetails(state, action: PayloadAction<TransactionDetailsResponse>) {
      state.transactionDetails = action.payload;
    }
  },
});

export const { setNearbyChargers, setTransactionDetails } = chargerDetailsSlice.actions;

export default chargerDetailsSlice.reducer;
